<template>
  <div class="top_order_info flex_row_start_center">
    <h3>确认订单</h3>
    <div class="top_logo">
      <div :style="`background-image:url(${configInfo.main_site_logo})`"></div>
    </div>
  </div>
  <div class="confirm_order_container">
    <div class="receive_info">
      <div class="receive_info_title">
        <span>收货信息</span>
      </div>
      <div class="receive_info_content flex_row_start_center adres_father">
        <div class="content_left flex_column_between_start" style="width: 700px">
          <span class="member">收货人：{{ orderAddress.data.memberName }}</span>
          <span>联系方式:{{ orderAddress.data.telMobile }}
            <div class="changeBtn">
              <div
                class="changeAdd"
                @click.stop="changeAddress"
              >
                更换地址
              </div>
              <div
                class="changeAdd"
                @click.stop="addAddress"
              >
                新增地址
              </div>
            </div>
          </span>
          <span class="addFather">
            <span
              :title="
                orderAddress.data.addressAll + orderAddress.data.detailAddress
              "
              class="address_detail overflow_ellipsis"
              style="width: 500px"
              >收货地址:{{ orderAddress.data.addressAll }}
              {{ orderAddress.data.detailAddress }}</span
            >
          </span>
        </div>
        <div class="content_right flex_column_center_center cont_right">
          <div class="cont_right">
            <div class="cont_right_title">
              发货港口:{{ orderPort.data.portName }}
            </div>
            <div class="changeBtn">
              <div class="add_address pointer" @click="changePort">更换港口</div>
              <div class="add_address pointer" @click="addPort">新增港口</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-else class="receive_info_content flex_row_center_center">
        <div class="add_address nomartop pointer" @click="addAddress">
          新建地址
        </div>
      </div> -->
    </div>
    <div
      v-for="(storeItem, index) in goods_data.data"
      :key="index"
      class="store_item"
    >
      <div class="store_name">
        <span style="width: 300px">{{ storeItem.factoryName }}</span>
        <span>成交价</span>
        <span>数量</span>
        <span>总价</span>
        <span>{{ storeItem.payType == 1 ? "定金" : "尾款" }}</span>
        <span>付款类型</span>
        <span>交货日</span>
        <span style="margin-right: 30px">付款总额</span>
      </div>
      <div class="good_container">
        <div class="good_item flex_row_start_center">
          <div
            class="good_info flex_row_start_center"
            style="position: relative"
          >
            <img class="good_image" :src="storeItem.image" alt />
            <div class="good_info_text" :style="storeItem.inquirySpec?'top:22px':''">
              <div class="good_name overflow_ellipsis_two">
                {{ storeItem.inquiryGoodsName }}
              </div>
              <div v-if="storeItem.inquirySpec" class="good_spec">
                {{ storeItem.inquirySpec }}
              </div>
            </div>
            <div class="good_price money">${{ storeItem.fboprice }}</div>
            <div class="num bynum">*{{ storeItem.buyNum }}</div>
            <div class="num totalFbo">${{ storeItem.totalFBOPrice }}</div>
            <div class="num addmoney" v-if="storeItem.payType == 1">
              ${{ storeItem.depositAmount }}
            </div>
            <div class="num addmoney" v-else>
              ${{ storeItem.balanceAmount }}
            </div>
            <div class="num paytype">
              {{ storeItem.payType == 1 ? "下单" : "尾款" }}
            </div>
            <div class="num time">
              {{ storeItem.deliveryTime }}
            </div>
            <div class="num manymoney">
              <span v-if="storeItem.payType == 1"
                >定金总额:${{ storeItem.depositAmount }}</span
              >
              <span v-else>尾款总额：${{ storeItem.balanceAmount }}</span>
              <!-- <span>优惠劵：{{}}</span> -->
              <span
                >交易手续费:${{
                  storeItem.payType == 1
                    ? storeItem.depositDealFee
                    : storeItem.balanceDealFee
                }}</span
              >
              <span
                >合计:${{
                  storeItem.payType == 1
                    ? storeItem.depositTotalPrice
                    : storeItem.balanceTotalPrice
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="store_item">
      <div class="store_coupon">
        <div class="store_coupon_title">
          <span>订单备注</span>
        </div>
        <div class="store_coupon_con flex_row_start_center">
          <el-input
            maxlength="100"
            v-model="remark"
            type="text"
            placeholder="给商家留言"
            show-word-limit
          />
        </div>
      </div>
      <div class="settle_info">
        <div class="total_money">
          <span>商品合计：</span>
          <span>${{ goodsAmount }}</span>
        </div>
        <!-- <div class="discount">
          <span>优惠：</span>
          <span class="red">-${{ totalDiscount }}</span>
        </div> -->
        <!-- <div class="shipping">
          <span>运费：</span>
          <span class="red">+${{ expressFee }}</span>
        </div> -->
      </div>
    </div>
    <div class="order_total_settle">
      <div class="order_price">
        <span>实付款（含运费）：</span>
        <span class="order_price_num">$ {{ totalAmount }}</span>
      </div>
      <div class="order_discount">
        <!-- <span>优惠了：</span> -->
        <!-- <span class="red">$ {{ order_settle_info.totalDiscount }}</span> -->
      </div>
      <div class="goBuy" @click="checkOrder" style="cursor: pointer">
        提交订单
      </div>
    </div>
    <!-- 地址选择弹窗 start -->
    <el-dialog
      title="更换地址"
      v-model="show_select_address"
      customClass="select_address_width"
      :before-close="handleClose"
      lock-sroll="false"
    >
      <div class="out_stock_dialog address_con">
        <div class="cheakCount">
          <div
            @click="trycheck(1)"
            :class="isType == 1 ? 'actives' : ''"
            class="pointer"
          >
            国内仓地址
          </div>
          <div
            @click="trycheck(2)"
            :class="isType == 2 ? 'actives' : ''"
            class="pointer"
          >
            海外仓地址
          </div>
        </div>
        <div
          v-for="(item, index) in address_list.data"
          :key="index"
          @click="selectAddress(index)"
          :class="{
            address_item: true,
            flex_column_start_start: true,
            select: current_address_index == index,
          }"
        >
          <span>收货人：{{ item.memberName }}</span>
          <span>联系方式：{{ item.telMobile }}</span>
          <span
            class="overflow_ellipsis address_text"
            :title="item.addressAll + item.detailAddress"
            >收货地址：{{ item.addressAll }} {{ item.detailAddress }}</span
          >
          <img
            v-if="current_address_index == index"
            class="selected"
            :src="invoice_selected"
            alt
          />
        </div>
      </div>
      <div class="btn_con flex_row_center_center">
        <div class="remove red" @click="confirmChangeAddress()">提交修改</div>
      </div>
    </el-dialog>
    <!-- 地址选择弹窗 end -->
    <!-- 港口选择弹窗 start -->
    <el-dialog
      title="更换港口"
      v-model="show_select_port"
      customClass="select_address_width"
      :before-close="handleClose"
      lock-sroll="false"
    >
      <div class="out_stock_dialog address_con">
        <div
          v-for="(item, index) in Port_list.data"
          :key="index"
          @click="selectPort(index)"
          :class="{
            address_item: true,
            flex_column_start_start: true,
            select: current_port_index == index,
          }"
        >
          <span>港口：{{ item.portName }}</span>

          <img
            v-if="current_port_index == index"
            class="selected"
            :src="invoice_selected"
            alt
          />
        </div>
      </div>
      <div class="btn_con flex_row_center_center">
        <div class="remove red" @click="confirmChangePort()">提交修改</div>
      </div>
    </el-dialog>
    <!-- 地址选择弹窗 end -->
    <SldAddressOperation
      v-if="addressVisibleFlag"
      @close="close"
      @refreshAddress="refreshAddress"
      :visibleFlag="true"
      :type="type"
      :addressType="addressType"
      changeType="true"
    />
    <!-- 添加新港口 -->
    <addgk
      v-if="addressVisibleFlag1"
      @close1="close1"
      @refreshAddress1="refreshAddress1"
      :visibleFlag="true"
      :type1="type1"    
      :areaData="options"
      changeType="true"
      :addressType="orderAddress.data.addressType"
    />
  </div>
</template>

<script>
import { reactive, getCurrentInstance, ref, onMounted, onUnmounted } from "vue";
import { ElDialog, ElInput, ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import SldAddressOperation from "../../components/AddressOperation";
import addgk from "../../components/addgk";
import { useStore } from "vuex";
export default {
  name: "ConfirmOrder",
  components: {
    ElDialog,
    ElInput,
    //  ElSelect,
    //  ElOption,
    SldAddressOperation,
    addgk
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const addressVisibleFlag = ref(false);
    const addressVisibleFlag1 = ref(false);
    const { proxy } = getCurrentInstance();
    const not_select = require("../../assets/buy/not_select.png");
    const selected = require("../../assets/buy/selected.png");
    const invoice_selected = require("../../assets/buy/invoice_selected.png");
    const couponCode = ref("");
    const platformCouponCode = ref("");
    const navlist = reactive({ data: [] });
    const show_change_address = ref(false);
    const edit_voice_dialog = ref(false);
    const add_voice_content = ref(false);
    const out_stock_dialog = ref(false);
    const type = ref("add");
    const type1 = ref("add");
    const addressType = ref('');
    const timer = ref(0); //定时器
    const no_good_info = reactive({ data: {} });
    const show_select_address = ref(false);
    const show_select_port = ref(false);
    const pre_params = reactive({ data: {} });
    const orderAddress = reactive({ data: "" });
    const orderPort = reactive({ data: "" });
    const address_list = reactive({ data: [] });
    const Port_list = reactive({ data: [] });
    const goods_data = reactive({ data: [] });
    const configInfo = ref(store.state.configInfo);
    const current_address_index = ref(0);
    const current_port_index = ref(0);
    const isType = ref(1);
    const countTypeList = ref([]);
    const countTypeList2 = ref([]);
    const replyIds = ref("");
    const select_invoice_info = reactive({
      invoiceId: "",
      invoiceContent: "",
      invoiceTitle: "",
    });
    const order_settle_info = reactive({
      totalAmount: "",
      totalDiscount: "",
      platformCouponList: [],
      platformCouponCode: "",
    });
    const remark = ref("");
    const goodsAmount = ref("");
    const totalAmount = ref("");
    const getportId = ref("");  
    
    const portList = reactive([]); //港口数组
    //用于切换地址，使用优惠券，获取信息，运费等
    const confirmOrder = () => {
      let replyId = replyIds.value.replyId;
      proxy
        .$post("/v3/goods/front/goods/inquiry/confirmEmploy", { replyId })
        .then((res) => {
          console.log(res);

          if (res.state == 200) {
            goods_data.data = res.data.orderProductVOS;
            totalAmount.value = res.data.totalAmount;
            goodsAmount.value = res.data.goodsAmount;
            getportId.value = res.data.portId;
          }
          console.log('getportId.value---这个---',getportId.value)
          
          getPortList()
          
        })
        .catch(() => {
          //异常处理
        });
    };
    
    //获取地址列表
    const getAddressList = () => {
      proxy
        .$get("v3/member/front/memberAddress/getList")
        .then((res) => {
          if (res.state == 200) {
            address_list.data = res.data;

            countTypeList.value = res.data.filter(function (item) {
              return item.addressType == 1;
            });
            countTypeList2.value = res.data.filter(function (item) {
              return item.addressType == 2;
            });
            console.log(countTypeList2, "countTypeList2");
            if (res.data.length > 0 && !orderAddress.data.addressId) {
              var default_address = res.data.filter(function (item) {
                return item.isDefault == true;
              });
              console.log('default_address---这个---default_address',default_address)
              if (default_address.length > 0) {
                orderAddress.data = default_address[0];
              } else {
                orderAddress.data = res.data[0];
              }
            }
            address_list.data = countTypeList.value;

            confirmOrder(1);
          } else {
            confirmOrder(1);
            ElMessage(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //  获取港口信息
    const getPortList = () => {
      let form = {};
      form.addressType = 1;
      proxy
        .$get("/v3/member/front/memberDeliverPort/list")
        .then((res) => {
          console.log('res---这个---res',res)
          if (res.state == 200) {
            
            Port_list.data = res.data.list;
            if (res.data.list.length > 0 && !orderPort.data.addressId) {
              
                let default_address1 = res.data.list.filter( item => {
                  console.log('getportId.value---configInfo',getportId.value)
                  if(item.portId === getportId.value){
                    console.log('item---item---',item)  
                    return item
                  }
                });
              console.log('default_address1---zhege---', default_address1)
              console.log('default_address1.portname---zhege---', default_address1[0].portName)
              if (default_address1.length > 0) {
                orderPort.data = default_address1[0];
              } else {
                orderPort.data = res.data.list[0];
              }
            }
            console.log(orderPort);
          } else {
            ElMessage(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    
    //切换地址
    const selectAddress = (index) => {
      current_address_index.value = index;
    };
    //  切换港口
    const selectPort = (index) => {
      current_port_index.value = index;
    };
    //确认修改地址
    const confirmChangeAddress = () => {
      orderAddress.data = address_list.data[current_address_index.value];
      show_select_address.value = false;
    };
    //确认修改港口
    const confirmChangePort = () => {
      orderPort.data = Port_list.data[current_port_index.value];
      show_select_port.value = false;
    };
    //弹出地址选择框
    const changeAddress = () => {
      getAddressList();
      show_select_address.value = true;
    };
    //  弹出港口选择
    const changePort = () => {
      getPortList();
      show_select_port.value = true;
    };
    const showAddvoice = () => {
      add_voice_content.value = true;
    };

    const removeAddvoice = () => {
      select_invoice_info.invoiceId = false;
      edit_voice_dialog.value = false;
    };
    //返回上一页
    const returnLastPage = () => {
      out_stock_dialog.value = false;
      router.go(-1);
    };

    //获取订单支付数据
    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value);
        timer.value = 0;
      }
    });
    //关闭弹窗
    const close = () => {
      addressVisibleFlag.value = false;
    };
    //关闭弹窗
    const close1 = () => {
      addressVisibleFlag1.value = false;
    };
    //弹出新建地址窗口
    const addAddress = () => {
      addressType.value = orderAddress.data.addressType;
      addressVisibleFlag.value = true;
    };
    // 弹出新建仓库窗口
    const addPort = () => {
      addressVisibleFlag1.value = true;
    };
    // 切换国内仓，海外仓
    const trycheck = (index) => {
      isType.value = index;
      if (index == 1) {
        address_list.data = countTypeList.value;
      } else {
        address_list.data = countTypeList2.value;
      }
    };
    //  去提交
    const checkOrder = () => {
      let item = {};
      item.orderPrice = totalAmount.value;
      item.goodsName = goods_data.data[0].inquiryGoodsName;
      item.memberName = goods_data.data[0].factoryName;
      item.bankName = goods_data.data[0].bankName;
      item.bankAccount = goods_data.data[0].bankAccount;
      item.receiverAreaInfo = orderAddress.data.addressAll;
      item.receiverAddress = orderAddress.data.detailAddress;
      console.log(item);
      let form = {};
      form.replyId = replyIds.value.replyId;
      form.orderFrom = 1;
      form.remark = remark.value;
      form.portId = orderPort.data.portId;
      form.addressId = orderAddress.data.addressId;
      proxy
        .$post(
          "/v3/business/front/orderOperate/employ",
          form,
          "application/json"
        )
        .then((res) => {
          console.log("res", res);
          if (res.state == 200) {
            // let item = {}
            item.orderSn = res.data.orderSn;
            item.paySn = res.data.paySn;
            item = JSON.stringify(item);
            localStorage.setItem("item", item);
            router.push({
              path: "/member/order/list",
            });
          } else {
            ElMessage(res.msg);
          }
        });
    };
    // 更新地址
    const refreshAddress = (addressInfo, addressId, changeType) => {
      orderAddress.data = addressInfo;
      orderAddress.data.addressId = addressId;
      if(changeType){
        addressVisibleFlag.value = false;
      }
    };
    // 更新仓库
    const refreshAddress1 = (addressInfo, portId, changeType) => {
      orderPort.data = addressInfo;
      orderPort.data.portId = portId;
      if(changeType){
        addressVisibleFlag1.value = false;
      }
    };

    onMounted(() => {
      replyIds.value = route.query;
      getAddressList();
      // getPortList();
    });
    return {
      navlist,
      replyIds,
      not_select,
      selected,
      show_change_address,
      edit_voice_dialog,
      invoice_selected,
      add_voice_content,
      portList,
      showAddvoice,
      removeAddvoice,
      out_stock_dialog,
      orderAddress,
      changeAddress,
      show_select_address,
      address_list,
      current_address_index,
      selectAddress,
      confirmChangeAddress,
      goods_data,
      pre_params,
      select_invoice_info,
      order_settle_info,
      confirmOrder,
      returnLastPage,
      no_good_info,
      addressVisibleFlag,
      addressVisibleFlag1,
      close,
      close1,
      addPort,
      type,
      type1,
      addressType,
      refreshAddress,
      refreshAddress1,
      addAddress,
      couponCode,
      platformCouponCode,
      configInfo,
      getPortList,
      orderPort,
      Port_list,
      remark,
      goodsAmount,
      totalAmount,
      getportId,
      checkOrder,
      show_select_port,
      changePort,
      current_port_index,
      selectPort,
      confirmChangePort,
      isType,
      countTypeList,
      countTypeList2,
      trycheck,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/confirmOrder.scss";
</style>
<style lang="scss" scoped>
.voice_width {
  width: 605px !important;
}
.add_voice_btn2 {
  margin: -30px 114px 10px !important;
}
.out_store_width {
  width: 480px !important;
}

.select_address_width {
  width: 500px !important;
}

.el-dialog__body {
  padding-top: 10px;
}

.el-input__inner {
  font-size: 12px;
}

.el-select .el-input__inner:focus {
  border-color: #e2231a;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #e2231a;
}

.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #e2231a;
  outline: 0;
}

.validateMessage {
  font-size: 12px;
  color: #e2231a;
  margin-top: 5px;
  padding-left: 80px;
  height: 12px;
}

.giftProduct {
  display: inline-block;
  border: 1px solid #e2231a;
  color: #e2231a;
  width: 33px;
  height: 16px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  margin-right: 4px;
}
.changeBtn {
  position: relative;
  height: 30px;
}
.changeAdd {
  margin-left: 20px;
  width: 100px;
  height: 30px;
  background-color: #e2231a;
  color: white;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
}
.changeBtn>.changeAdd:first-of-type {
  position: absolute;
  bottom: 38px;
}
.addFather {
  display: flex;
}
.cont_right {
  display: flex;
  flex-direction: row;
}
.cont_right_title {
  /* background-color: red; */
  line-height: 90px;
  margin-right: 40px;
}
.store_name {
  display: flex;
  justify-content: space-between;
}
.money {
  position: absolute;
  left: 290px;
  top: 35px;
}
.bynum {
  position: absolute;
  left: 520px;
  top: 35px;
}
.totalFbo {
  position: absolute;
  left: 625px;
  top: 35px;
}
.addmoney {
  position: absolute;
  left: 730px;
  top: 35px;
}
.paytype {
  position: absolute;
  left: 850px;
  top: 35px;
  width: 40px;
}
.overflow_ellipsis_two1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.time {
  position: absolute;
  left: 920px;
  top: 35px;
  width: 140px;
}
.manymoney {
  position: absolute;
  left: 1020px;
  top: 0px;
  width: 140px;
  display: flex;
  flex-direction: column;
  span {
    margin-top: 10px;
    text-align: right;
  }
}
.cheakCount {
  position: absolute;
  display: flex;
  // margin-top: 20px;
  top: 15px;
  left: 100px;
  div {
    margin-left: 20px;

    padding: 10px 20px;
  }
}
.actives {
  border-bottom: 2px solid red;
}
</style>
